<script setup lang="ts">
defineProps({
  fill: {
    type: String as PropType<string>,
    required: false,
    default: "#000000",
  },
  width: {
    type: String as PropType<string>,
    required: false,
    default: "115",
  },
  height: {
    type: String as PropType<string>,
    required: false,
    default: "96",
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 115 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="25.73"
      cy="29.8224"
      r="25.0873"
      transform="rotate(-3.8864 25.73 29.8224)"
      :fill="fill"
    />
    <circle
      cx="85.9707"
      cy="25.73"
      r="25.0873"
      transform="rotate(-3.8864 85.9707 25.73)"
      :fill="fill"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.8542 94.2082L51.5796 40.2618L53.8315 41.4609L25.1061 95.4073L22.8542 94.2082Z"
      :fill="fill"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M83.3791 90.0965L112.105 36.1501L114.356 37.3492L85.631 91.2956L83.3791 90.0965Z"
      :fill="fill"
    />
  </svg>
</template>
